import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../helpers/reducerRegistry'
import { SELECT_FIELD } from '../constants'
import {
  getCountries,
  getJobTitles,
  getUserProfile,
  getUserProfileFields,
  postUpdateUserProfileRequest,
  putUserProfile,
} from './thunk'

const slice = createSlice({
  name: 'userManagement',
  initialState: {
    userProfile: {},
    listFieldRequest: [
      {
        label: SELECT_FIELD.label,
        value: 'none',
        inputValue: '',
        isI18n: true,
        fieldCode: 'none',
      },
    ],
    isLoadingUserProfile: true,
    isSendingRequestSuccess: false,
    jobTitleList: [],
    countriesList: [],
    listSelectionRequest: [],
  },
  reducers: {
    setListFieldRequest: (state, action) => {
      state.listFieldRequest = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUserProfile.pending, (state) => {
      state.isLoadingUserProfile = true
    })
    builder.addCase(getUserProfile.fulfilled, (state, action) => {
      state.isLoadingUserProfile = false
      state.userProfile = action.payload
    })
    builder.addCase(getUserProfile.rejected, (state) => {
      state.isLoadingUserProfile = false
    })

    builder.addCase(postUpdateUserProfileRequest.pending, (state) => {
      state.isSendingRequestSuccess = false
    })
    builder.addCase(postUpdateUserProfileRequest.fulfilled, (state, action) => {
      state.isSendingRequestSuccess = action.payload.success
    })
    builder.addCase(postUpdateUserProfileRequest.rejected, (state) => {
      state.isSendingRequestSuccess = false
    })

    builder.addCase(putUserProfile.pending, (state) => {
      state.isSendingRequestSuccess = false
    })
    builder.addCase(putUserProfile.fulfilled, (state, action) => {
      state.isSendingRequestSuccess = action.payload.success
    })
    builder.addCase(putUserProfile.rejected, (state) => {
      state.isSendingRequestSuccess = false
    })

    builder.addCase(getJobTitles.fulfilled, (state, action) => {
      const payloadData = action.payload || []
      state.jobTitleList = payloadData.map((item) => ({
        ...item,
        value: item.id,
        label: item.name,
      }))
    })

    builder.addCase(getCountries.fulfilled, (state, action) => {
      const payloadData = action.payload || []
      state.countriesList = payloadData.map((item) => ({
        ...item,
        value: item.code,
        label: item.name,
      }))
    })

    builder.addCase(getUserProfileFields.fulfilled, (state, action) => {
      const payloadData = action.payload || []
      state.listSelectionRequest = payloadData.map((item) => ({
        ...item,
        value: item.fieldCode,
        label: item.fieldName,
      }))
    })
  },
})

export const { setListFieldRequest } = slice.actions

export const selectUserProfile = (state) => state[slice.name].userProfile
export const selectListFieldRequest = (state) =>
  state[slice.name].listFieldRequest
export const selectLoadingUserProfile = (state) =>
  state[slice.name].isLoadingUserProfile
export const selectSendingRequestSuccess = (state) =>
  state[slice.name].isSendingRequestSuccess
export const selectJobTitlesList = (state) => state[slice.name].jobTitleList
export const selectCountriesList = (state) => state[slice.name].countriesList
export const selectListSelectionRequest = (state) =>
  state[slice.name].listSelectionRequest

register(slice.name, slice.reducer)
